import React from 'react';
import { Button, Row } from 'react-bootstrap';
import '../assets/css/dashboard.scss'
import '../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import Download from './MainSection/Download/Download';
import { useNavigate } from 'react-router-dom';
import Main from './Main';
import accessDenied from '../assets/images/access-denied.svg'
import { SbAddBtn, SBPreviousBtn, SBSaveUpdateBtn } from './Buttons/Buttons';

const AccessDenied = () => {

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                    // showBackButton={true}
                    // moduleName="Settings / Roles"
                    // onBackClick={handleBack}
                    />
                </div>
                <div className='d-flex align-items-center justify-content-center p-6'>
                    <div>
                        <img src={accessDenied} alt="" />
                    </div>
                    <div>
                        <span style={{ color: "rgba(6, 201, 244, 1)", fontWeight: "600" }}>Access Denied</span>
                        <p className='pt-2 pb-2'>Sorry 403 you do't have permission to access this page
                            you can go back to previous page</p>
                        <SBSaveUpdateBtn onClickEffect={handleBack} btnName="previous Page" />
                    </div>
                </div>
            </Main>
        </div >
    );
};

export default AccessDenied;